module.exports = __webpack_public_path__ + "static/media/21.828a63a7.webp";